export const themeColors = {
    blue: {
        50: '#e4f1ff', 100: '#bfdcff', 200: '#95c7ff', 300: '#6bb1ff', 400: '#519fff',
        500: '#458eff', 600: '#487fff', 700: '#486cea', 800: '#4759d6', 900: '#4536b6',
        label: 'Blue',
        className: 'primary'
    },
    magenta: {
        50: '#f0e1ff', 100: '#ebd7ff', 200: '#dcc0f8', 300: '#cd9ffa', 400: '#c48afe',
        500: '#b66dff', 600: '#8252e9', 700: '#6f37e6', 800: '#601eef', 900: '#4815b3',
        label: 'Magenta',
        className: 'lilac'
    },
    orange: {
        50: '#fefce8', 100: '#fef9c3', 200: '#fef08a', 300: '#fde047', 400: '#facc15',
        500: '#eab308', 600: '#ff9f29', 700: '#f39016', 800: '#e58209', 900: '#d77907',
        label: 'Orange',
        className: 'warning' // mapped to warning in css based on previous check
    },
    green: {
        50: '#f0fdf4', 100: '#dcfce7', 200: '#bbf7d0', 300: '#86efac', 400: '#4ade80',
        500: '#22c55e', 600: '#16a34a', 700: '#15803d', 800: '#166534', 900: '#14532d',
        label: 'Green',
        className: 'success'
    },
    red: {
        50: '#fef2f2', 100: '#fee2e2', 200: '#fecaca', 300: '#fca5a5', 400: '#f87171',
        500: '#ef4444', 600: '#dc2626', 700: '#b91c1c', 800: '#991b1b', 900: '#7f1d1d',
        label: 'Red',
        className: 'danger'
    },
    blueDark: {
        50: '#eff6ff', 100: '#dbeafe', 200: '#bfdbfe', 300: '#93c5fd', 400: '#60a5fa',
        500: '#3b82f6', 600: '#2563eb', 700: '#1d4ed8', 800: '#1e40af', 900: '#1e3a8a',
        label: 'Blue Dark',
        className: 'info'
    },
    cyan: {
        50: '#e2f5fb', 100: '#daf6ff', 200: '#85daf4', 300: '#6cdafc', 400: '#48cef7',
        500: '#2bc9f9', 600: '#00b8f2', 700: '#03a9dc', 800: '#049dcb', 900: '#0390bb',
        label: 'Cyan',
        className: 'cyan'
    }
};

export const applyTheme = (themeColor, persist = true) => {
    const colors = themeColors[themeColor];
    if (colors) {
        const root = document.documentElement;
        Object.keys(colors).forEach(key => {
            if (key !== 'label' && key !== 'className') {
                root.style.setProperty(`--primary-${key}`, colors[key]);
            }
        });
        if (persist) {
            localStorage.setItem('themeColor', themeColor);
        }
        window.dispatchEvent(new Event('themeChanged'));
    }
};

export const initTheme = () => {
    const savedTheme = localStorage.getItem('themeColor');
    if (savedTheme && themeColors[savedTheme]) {
        applyTheme(savedTheme, false); // No need to persist again, just apply
    }
};

export const getPrimaryColor = () => {
    return getComputedStyle(document.documentElement).getPropertyValue('--primary-600').trim() || '#487fff';
};
